import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';
import {SortField} from 'src/openapi/admin/models/SortField';

import {SortHeaderFilter} from '@pb/kit-component-filters';


import {useNotificationTopics} from '../../../hook/useNotificationTopics';
import {COLUMNS, HEADERS} from '../../constants';
import {
    notificationsListStateActions,
    notificationsListStateSelector,
} from '../../slices/notification-search-criteria.slice';

import {NotificationTopicFilter} from './notification-topic.filter';


export const NotificationTopicHeader = () => {
    const dispatch = useDispatch();
    const state = useSelector(notificationsListStateSelector);
    const [topic, setTopic] = useState(state.filters.topic);
    const {data: topics} = useNotificationTopics();

    useEffect(() => {
        setTopic(state.filters.topic);
    }, [state.filters.topic]);

    const applyFilter = useCallback(() => {
        if (state.filters.topic !== topic) {
            const {topic: _topic, ...filters} = state.filters;
            dispatch(notificationsListStateActions.setFilters({
                ...filters,
                ...topic ? {topic} : {},
            }));
        }
    }, [topic, state.filters, dispatch]);

    const sort = useCallback((direction: 'ASC' | 'DESC') => {
        dispatch(notificationsListStateActions.setSortCriteria({
            field: SortField.TOPIC,
            direction: direction as SortDirections,
        }));
        applyFilter();
    }, [dispatch, applyFilter]);

    const clearFilter = useCallback(() => {
        const {topic: _topic, ...filters} = state.filters;
        setTopic(undefined);
        dispatch(notificationsListStateActions.setFilters(filters));
    }, [dispatch, state, setTopic]);

    const cancelFilter = useCallback(() => {
        setTopic(state.filters.topic);
    }, [state]);

    return (
        <SortHeaderFilter
            filterActive={!!topic}
            sortable={true}
            caption={HEADERS[COLUMNS.TOPIC]}
            direction={state.sortCriteria.field === SortField.TOPIC
                ? state.sortCriteria.direction
                : undefined}
            defaultDirection={SortDirections.ASC}
            onSort={sort}
            onApply={applyFilter}
            onReset={clearFilter}
            onCancel={cancelFilter}>
            <NotificationTopicFilter
                topics={topics}
                onChange={setTopic}
                selectedTopic={topic as string}
            />
        </SortHeaderFilter>
    );
};
